var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"abstretch"},[_c('view-asset-history',{attrs:{"assetId":_vm.assetId,"save-route":""},model:{value:(_vm.currentVersion),callback:function ($$v) {_vm.currentVersion=$$v},expression:"currentVersion"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }